import { useState } from 'react'

import { useSearchActions, useSearchState } from '../../stores/search'

import ConfirmDialog from '@/components/common/ConfirmDialog'
import { palletV2Service } from '@/services'
import { PalletResult } from '@/services/SearchV2Service'
import { useUIStore } from '@/stores/useUIStore'

const PalletCard = () => {
  const { showError } = useUIStore()
  const { searchResult, loading } = useSearchState()
  const { openLoading, closeLoading, setQuerySearch, fetchQueryResult } =
    useSearchActions()
  // 类型断言确保 searchResult 是 PalletResult 类型
  const palletResult = searchResult as PalletResult

  const [assignVisiable, setAssignVisiable] = useState<boolean>(false)
  const [positionCodeValue, setPositionCodeValue] = useState<string>('')
  const [assignCancelVisible, setAssignCancelVisible] = useState<boolean>(false)

  // 处理托盘点击事件
  const handlePalletClick = (palletCode: string) => {
    // 这里可以添加跳转到托盘详情页面或其他操作
    setQuerySearch(palletCode)
    fetchQueryResult()
  }

  const handlePositionClick = (positionCode: string) => {
    // 这里可以添加跳转到托盘详情页面或其他操作
    setQuerySearch(positionCode)
    fetchQueryResult()
  }

  const handleAssignPositionCancel = async () => {
    openLoading()
    try {
      await palletV2Service.unbindPosition(palletResult.id)
      setAssignCancelVisible(false)
      fetchQueryResult()
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : '解除绑定库位失败'
      showError(errorMessage)
    } finally {
      closeLoading()
    }
  }

  const handleAssignPosition = async () => {
    if (!positionCodeValue) {
      showError('请输入库位编号')
      return
    }
    // 这里可以添加分配库位的逻辑
    openLoading()
    try {
      await palletV2Service.bindPosition(palletResult.id, {
        position_code: positionCodeValue
      })

      // 分配成功后重新搜索获取最新数据
      fetchQueryResult()

      setAssignVisiable(false)
      setPositionCodeValue('')
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : '分配库位失败'
      showError(errorMessage)
    } finally {
      closeLoading()
    }
  }

  return (
    <>
      <div className="divide-y divide-dashed divide-gray-300">
        {/* 托盘信息 */}

        <div className="flex justify-between items-center py-3">
          {palletResult.warehousePosition?.code ? (
            <div className="w-full flex flex-row gap-3 flex-shrink-0">
              <button
                onClick={() => setAssignVisiable(true)}
                className="w-full p-3 font-medium text-orange-600 bg-orange-50 border border-orange-200 rounded-md hover:bg-orange-100 hover:border-orange-300 transition-colors"
              >
                移位
              </button>
              <button
                className="w-full p-3 font-medium text-red-600 bg-red-50 border border-red-200 rounded-md hover:bg-red-100 hover:red-orange-300 transition-colors"
                onClick={() => setAssignCancelVisible(true)}
              >
                撤出
              </button>
            </div>
          ) : (
            <button
              onClick={() => setAssignVisiable(true)}
              className="w-full p-3 font-medium text-red-600 bg-red-50 rounded-md transition-colors"
            >
              分配库位
            </button>
          )}
        </div>

        {palletResult.warehousePosition && (
          <div className="flex justify-between items-center py-3 ">
            <span className="text-sm font-medium text-gray-600">库位编号</span>
            <span
              className="text-sm font-semibold  text-blue-600 hover:text-blue-800 cursor-pointer underline"
              onClick={() =>
                handlePositionClick(palletResult.warehousePosition.code)
              }
            >
              {palletResult.warehousePosition.name}
            </span>
          </div>
        )}
        {/*{palletResult.warehousePosition && (
          <div className="flex justify-between py-3 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">区域名称</span>
            <span className="text-sm font-semibold text-gray-900">
              {palletResult.warehousePosition.name}
            </span>
          </div>
        )}*/}
        {/* <div className="flex justify-between py-3 border-b border-gray-100">
          <span className="text-sm font-medium text-gray-600">分提单号</span>
          <span className="text-sm font-semibold text-gray-900">
            {palletResult}
          </span>
        </div> */}
        <div className="flex justify-between py-3 border-b border-gray-100">
          <span className="text-sm font-medium text-gray-600">MARKS号</span>
          <span>
            {palletResult.cargoMarks &&
              palletResult.cargoMarks.map((mark) => (
                <span
                  key={mark.id}
                  className="text-sm font-semibold text-blue-600 hover:text-blue-800 cursor-pointer underline ml-2"
                  onClick={() => handlePalletClick(mark.cargoMark.cargoNumber)}
                >
                  {mark.cargoMark.cargoNumber}
                </span>
              ))}
          </span>
        </div>
        <div className="flex justify-between py-3 border-b border-gray-100">
          <span className="text-sm font-medium text-gray-600">总箱数</span>
          <span className="text-sm font-semibold text-gray-900">
            {palletResult.quantity}
          </span>
        </div>
        <div className="flex justify-between py-3 border-b border-gray-100">
          <span className="text-sm font-medium text-gray-600">状态</span>
          <span className="text-sm font-semibold text-gray-900">
            {palletResult.statusDisplay}
          </span>
        </div>
      </div>

      {/* 分配库位弹窗 */}
      <ConfirmDialog
        isOpen={assignVisiable}
        title="分配库位"
        confirmText="确认分配"
        cancelText="取消"
        onConfirm={handleAssignPosition}
        onCancel={() => setAssignVisiable(false)}
        isLoading={loading}
        maxWidth="lg"
      >
        <div className="space-y-4">
          <input
            type="text"
            value={positionCodeValue}
            onChange={(e) => setPositionCodeValue(e.target.value.trim())}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="请输入库位编号"
          />
        </div>
      </ConfirmDialog>

      <ConfirmDialog
        isOpen={assignCancelVisible}
        title="撤出库位"
        onCancel={() => setAssignCancelVisible(false)}
        onConfirm={handleAssignPositionCancel}
      >
        <div className="space-y-4">
          <p>您确定要撤出库位吗？</p>
        </div>
      </ConfirmDialog>
    </>
  )
}

export default PalletCard
